import { gql } from "@apollo/client";

export const GET_EVENTS_BY_NAME = gql`
  query getEventsByName($search: String!, $limit: Int, $eventLive: Boolean, $radius: Float, $location: EventLocationInput) {
    eventsByName(search: $search, limit: $limit, eventLive: $eventLive, radius: $radius, location: $location) {
      id
      name
      status
      date
      daysWindow
      location {
        id
        formattedAddress
      }
      organisation {
        id
        name
        logo
        sportType
      }
    }
  }
`;

export const GET_ORGANISATIONS_BY_NAME = gql`
  query getOrganisationsByName($search: String!, $limit: Int, $location: EventLocationInput) {
    organisationsByName(search: $search, limit: $limit, location: $location) {
      id
      name
      shortName
      logo
      sportType
    }
  }
`;
